import { css } from '@emotion/react';
import { semantic_colors } from '../../foundation';
import { PageIndicatorItemSize } from './types';

export const size_styles = {
  medium: {
    dot: 8,
    selected: 20,
    gap: 2,
  },
  small: {
    dot: 6,
    selected: 15,
    gap: 0,
  },
};

export const getPageIndicatorItemBaseStyle = (size: PageIndicatorItemSize) => {
  const { dot } = size_styles[size];

  return css`
    font-size: 0;
    margin: 0;
    padding: 4px;
    cursor: pointer;
    border: none;
    background: none;

    &::before {
      content: '';
      display: inline-block;
      width: ${dot}px;
      height: ${dot}px;
      background: ${semantic_colors.content.primary};
      opacity: 0.2;
      border-radius: ${dot}px;
      transition: width 0.15s ease-out, opacity 0.1s linear;
    }

    &:hover::before {
      opacity: 0.3;
    }
    &:active::before {
      opacity: 0.4;
    }
    &:disabled {
      cursor: default;
    }
    &:disabled::before {
      opacity: 0.1;
    }
  `;
};

export const getPageIndicatorItemSelectedStyle = (size: PageIndicatorItemSize) => {
  const { selected } = size_styles[size];

  return css`
    &::before {
      width: ${selected}px;
      opacity: 1;
    }
    &:hover::before,
    &:active::before {
      opacity: 1;
    }
    &:disabled::before {
      opacity: 0.4;
    }
  `;
};
